//src/app/services/constants/index.ts
import { DocumentsFiltersType } from 'app/features/documents/DocumentsFilters';
import {
  buildQueryParams,
  IGetQueryParams,
  IPaginatedDirectoryRepsonse,
  publicAPI,
} from '../index';

export interface ITimezone {
  abbr: string;
  id: number;
  text: string;
  value: string;
}

export interface ILanguage {
  id: number;
  name: string;
}

const constantsAPI = publicAPI.injectEndpoints({
  endpoints: (b) => ({
    getTimeZones: b.query<ITimezone[], void>({
      providesTags: ['Timezones'],
      query: () => 'time_zones',
      transformResponse: (response: { timezones: ITimezone[] }) =>
        response.timezones,
    }),
    getLanguages: b.query<ILanguage[], void>({
      providesTags: ['Languages'],
      query: () => 'languages',
      transformResponse: (response: { languages: ILanguage[] }) =>
        response.languages.sort((l1, l2) => l1.name.localeCompare(l2.name)),
    }),
    getGuestDirectoryItems: b.query<
      IPaginatedDirectoryRepsonse,
      IGetQueryParams<
        {
          search?: string;
          // folder_id?: number;
        } & DocumentsFiltersType
      >
    >({
      query: (params) =>
        `/file_objects/guest_show${buildQueryParams(params, true)}`,
    }),
  }),
});

export const {
  useGetTimeZonesQuery,
  useGetLanguagesQuery,
  useGetGuestDirectoryItemsQuery,
  useLazyGetGuestDirectoryItemsQuery,
} = constantsAPI;
